import { api } from '../../lib/apiClient';
import { useAuthStore } from '../../store/authStore';

function ws() {
  const workspaceId = useAuthStore.getState().workspaceId;
  if (!workspaceId) throw new Error('No active workspace selected');
  return `/workspaces/${workspaceId}`;
}

/** Full-text search within the active workspace (files, folders, comments, secrets, signature documents). */
export async function search(q, { type, limit, offset } = {}) {
  const { data } = await api.get(`${ws()}/search`, {
    params: { q, ...(type ? { type } : {}), ...(limit ? { limit } : {}), ...(offset ? { offset } : {}) },
  });
  return data; // { data: SearchHit[], total }
}
